// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HeaderLinkModel } from "@hardwoods/Overrides/Widgets/Header/HeaderLinkList";
import { MappedLink } from "@hardwoods/Overrides/Widgets/Header/MainNavigation";
import { pickMultiple } from "@hardwoods/XDL/Utilities";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { newGuid } from "@insite/client-framework/Common/StringHelpers";
import { getPageLinkByNodeId, useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";

interface HeaderLink {
    iconSrc?: string;
    id?: string;
    linkType?: string;
    openInNewWindow?: boolean;
    overriddenTitle?: string;
    title?: string;
    type?: string;
    url?: string;
    children?: MappedLink[];
}

export const useHeaderLinkList = (linksField: HeaderLinkModel[]) => {
    const pickKeys = ["iconSrc", "id", "linkType", "openInNewWindow", "overriddenTitle"] as const;
    const links = linksField?.map(item => {
        const linkField = { ...item.fields, id: newGuid() };
        if (linkField.linkType === "link") {
            const link = useGetLink(linkField.destination);
            return {
                ...pickMultiple(linkField, pickKeys),
                url: link.url,
                title: link.title || linkField.overriddenTitle,
            };
        }
        if (linkField.linkType === "phone") {
            return {
                ...pickMultiple(linkField, pickKeys),
                url: linkField.phone,
                title: linkField.overriddenTitle || linkField.phone,
            };
        }
        if (linkField.linkType === "menu" && linkField.destination?.type === "Page") {
            const readonlyPageLink = useAppSelector(state => getPageLinkByNodeId(state, linkField.destination?.value));
            return {
                ...pickMultiple(linkField, pickKeys),
                children: readonlyPageLink?.children,
                type: readonlyPageLink?.type,
                url: readonlyPageLink?.url,
                title: linkField.overriddenTitle || readonlyPageLink?.title,
            };
        }
        return {
            ...pickMultiple(linkField, pickKeys),
            url: undefined,
            title: "",
        };
    }) as HeaderLink[];

    return links;
};
